<div class="hide-account-status-bar-wrapper">
    <button status="danger" class="hide-account-status-bar-button" nbButton (click)="openHideAccountStatusBarDialog()">
        <nb-icon icon="close-outline"></nb-icon>
    </button>
</div>
